import TextDiff from "@/helpers/editor/TextDiff.js";

export default {
    namespaced: true,
    state: () => ({
        enabled: false,
        display: `compare`,//before, compare, after
        type: `suggestion`,
        suggestions: [],
        reason: true
    }),
    actions: {
        async enableTextDiff({state}, payload) {
            state.suggestions = [];
            state.enabled = true;
            if (payload.type) {
                state.type = payload.type;
            }
            for (let suggestion of payload.suggestions) {
                const textDiff = new TextDiff(suggestion, payload.page, payload.language);
                state.suggestions.push(textDiff);
            }
        }
    }
}
